export enum SessionStatusEnum {
  Success = 'Success',
  Uncompleted = 'Uncompleted test',
  Untested = 'Untested user',
}
